import { render, staticRenderFns } from "./RowForm.vue?vue&type=template&id=6561279e&scoped=true&"
import script from "./RowForm.vue?vue&type=script&lang=js&"
export * from "./RowForm.vue?vue&type=script&lang=js&"
import style0 from "./RowForm.vue?vue&type=style&index=0&id=6561279e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6561279e",
  null
  
)

export default component.exports